// Load all JSON templates
import defectAnalytics from "../../templates/defectAnalytics.json";
import storyRtm from "../../templates/story-rtm.json";
import testRtm from "../../templates/test-rtm.json";
// Add more templates here as needed

// Mapping templateId to JSON
const TEMPLATES = {
  "defectAnalytics": defectAnalytics,
  "storyRtm": storyRtm,
  "testRtm": testRtm,
};  

/**
 * Returns template fields array for a given templateId
 * @param {string} templateId
 * @returns {Array<{id: string, label: string, mandatory: boolean}>}
 */
export function getTemplateFields(templateId) {
  const tpl = TEMPLATES[templateId];
  if (!tpl || !tpl.columns) return [];

  return tpl.columns.map((col) => ({
    id: col.key || col.id,      // Support "key" or "id" in JSON
    label: col.label || col.name, // Support "label" or "name"
    mandatory: !!col.required || !!col.mandatory,
  }));
}

/**
 * Returns the full template JSON by templateId
 * Useful if you need name, description, or columns
 * @param {string} templateId
 * @returns {object|null}
 */
export function getTemplate(templateId) {
  return TEMPLATES[templateId] || null;
}

/**
 * Returns list of all template IDs
 */
export function getAllTemplateIds() {
  return Object.keys(TEMPLATES);
}
